import React from 'react';
import { BOSS } from '../partials/store/BOSS';
import { InStock } from '../partials/store/InStock';
import { InStockNearby } from '../partials/store/InStockNearby';
import { LimitedAvailability } from '../partials/store/LimitedAvailability';
import { LimitedAvailabilityNearby } from '../partials/store/LimitedAvailabilityNearby';
import { NotLocalized } from '../partials/store/NotLocalized';
import { NoStoreOption } from '../partials/store/NoStoreOption';
import { LiveGoodsMessaging } from '../partials/store/LiveGoodsMessaging';
import { BopisOffMessage } from '../partials/store/BopisOffMessage';
import { EmptyStoreMessage } from '../partials/store/EmptyStoreMessage';
import { dataModel } from '../../components/dataModel';

import {
  getSellableQuantityYourStore,
  // getStoreStatus,
  // hasZeroStock,
  isBOPIS,
  isBOSS,
  isBrowseOnly,
  isBuyInStore,
  // isCurrentlyUnavailable,
  isDiscontinued,
  // isInStock,
  isLimitedStock,
  isInStockYourStore,
  isInStockNearby,
  isLimitedStockNearby,
  isOutOfStockYourStore,
  isLiveGoods,
  isAppliance,
  isOutOfStockBoss,
  isOutOfStockOnline
} from './pod-fulfillment-utils';
import { GCC_COUNTER_TOPS } from '../../components/constants';

export const getStoreTemplate = ({ product, storeId }) => {
  const isGCCCounter = product?.info?.globalCustomConfigurator?.customExperience === GCC_COUNTER_TOPS;
  if (!product || isGCCCounter) return EmptyStoreMessage;

  if (isLiveGoods(product)) {
    const qty = getSellableQuantityYourStore(product);
    if (!qty) { return LiveGoodsMessaging; }
    if (qty > 0) { return InStock; }
  }

  if (storeId) {
    /* -----Browse Only----- */
    if (isBrowseOnly(product)) {
      /* Browse only, Non purchasable online and store must be purchased in store */
      // @TODO: What is getStoreStatus 400? Test in stage with 304384882.
      // if (getStoreStatus(sku) === 400) {
      //   return NoStoreOption;
      // }
      if (isBOPIS(product)) {
        return BopisOffMessage;
      }
      return LimitedAvailability;
    }

    /* -----BOPIS----- */
    if (isBOPIS(product)) {
      if (isBuyInStore(product)) { return BopisOffMessage; }
      if (isLimitedStock(product)) {
        if (isInStockNearby(product)) { return InStockNearby; }
        return LimitedAvailability;
      }
      if (isLimitedStockNearby(product)) { return LimitedAvailabilityNearby; }
      if (isInStockYourStore(product)) { return InStock; }
      if (isInStockNearby(product)) { return InStockNearby; }
    }

    /* -----BOSS----- */
    if (isBOSS(product)) {
      return BOSS;
    }

    /* -----No BOSS or BOPIS----- */
    // @TODO: What is in stock?
    // if (isInStock(product) || hasZeroStock(product) || isLimitedStock(product)) {
    //   /* Not BOPIS but has qtyForSale */
    //   return <LimitedAvailability localizedStore={localizedStore} channel={channel} />;
    // }
    if (isAppliance(product) || isDiscontinued(product)) {
      return EmptyStoreMessage;
    }
    if (isOutOfStockYourStore(product)) {
      return () => (
        <NoStoreOption
          storeMessage="Unavailable at "
          enableNearbyStore
          product={product}
        />
      );
    }
    if (isOutOfStockBoss(product) || isOutOfStockOnline(product)) {
      return () => (
        <NoStoreOption
          storeMessage="Unavailable"
          enableNearbyStore={false}
          product={product}
        />
      );
    }
    if (product?.availabilityType?.type === 'Shared') {
      return () => (
        <NoStoreOption
          storeMessage="Unavailable at "
          enableNearbyStore
          product={product}
        />
      );
    }
    /* Not Sold in Stnpmores */
    return () => (
      <NoStoreOption
        storeMessage="Not sold in stores"
        enableNearbyStore={false}
        product={product}
      />
    );
  }
  return NotLocalized;
};

getStoreTemplate.dataModel = dataModel;
